export const LOYALTY_TO_VIP_MAP: Record<number, number> = {
  8: 1,
  9: 2,
  10: 3,
  11: 4,
  12: 5,
};

export const VIP_TO_NAME_MAP: Record<number, string> = {
  1: 'bronze',
  2: 'silver',
  3: 'gold',
  4: 'emerald',
  5: 'diamond',
};
